// types
import {
	AccountType,
	EntitySubtype,
	EntityType,
	Financier,
	IlapCategory,
	TransactionType,
} from '../../../@types';

// ui
import { IconCircleProps } from './IconCircle';

export const accountIconTypes: Record<AccountType, IconCircleProps['type']> = {
	DESIGNATED: 'account',
	LOCAL: 'local',
};

// Map entity types to appropriate icon types for visual representation
export const entityIconTypes: Partial<Record<EntityType, IconCircleProps['type']>> = {
	AUDITOR: 'auditor',
	BENEFICIARY: 'individual',
	BORROWER: 'borrower',
	DONOR: 'donor',
	INTERMEDIARY: 'entity',
	PIU: 'entity',
	SUB_PIU: 'subPiu',
	SUPPLIER: 'supplier',
	TAX_AUTHORITY: 'tax',
};

// Map entity subtypes to appropriate icon types for visual representation
export const entityIconSubtypes: Record<EntitySubtype, IconCircleProps['type']> = {
	INDIVIDUAL: 'individual',
	ORGANIZATION: 'organization',
};

// Map financier types to appropriate icon types for visual representation
export const financierIconTypes: Record<Financier, IconCircleProps['type']> = {
	COFN: 'loan',
	GOV: 'government',
	IBRD: 'loan',
	IDA: 'loan',
	OTH: 'other',
	TF: 'loan',
};

// Map ILAP categories to appropriate icon types for visual representation
export const ilapCategoryIconTypes: Record<IlapCategory, IconCircleProps['type']> = {
	ILAP_BAD_MESSAGE: 'warning',
	ILAP_BLOCKCHAIN: 'cube',
	ILAP_CURRENCY_MISMATCH: 'payment',
	ILAP_DB: 'warning',
	ILAP_FINE: 'check',
	ILAP_INVALID_AMOUNT: 'payment',
	ILAP_NO_BANK_FOUND: 'account',
	ILAP_NO_DA_FOUND: 'account',
	ILAP_NO_PROJECT_FOUND: 'project',
	ILAP_NO_SUPPLIER_FOUND: 'supplier',
	ILAP_NO_WBG_WALLET_FOUND: 'account',
};

// Map transaction types to appropriate icon types for visual representation
export const transactionIconTypes: Record<TransactionType, IconCircleProps['type']> = {
	ADVANCE: 'advance',
	CASH_BENEFIT: 'cashBenefit',
	DIRECT: 'direct',
	INITIAL: 'payment',
	NON_CASH_BENEFIT: 'nonCashBenefit',
	OPEX: 'opex',
	PAYMENT: 'payment',
	PAYMENT_REFUND: 'refund',
	REIMBURSEMENT: 'reimbursement',
	REPLENISHMENT: 'replenishment',
	SPECIAL: 'specialCommitment',
	TRANSFER: 'transfer',
};
